
import { Component, HostListener } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';

import { PrimeModule } from '@module';

import { CoreTranslateService, LayoutsService } from 'pn-core-code';

import { PrimeNG } from 'primeng/config';
import { ProgressBarModule } from 'primeng/progressbar';

import configTheme from './configTheme';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [PrimeModule, RouterOutlet, ProgressBarModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  title = 'wongpanit-cms';

  isRouterLoading: boolean = false;
  routerLoadingValue: number = 0;
  errorMessage: string;

  intervalL: any;

  constructor(
    private config: PrimeNG,
    private layoutsService: LayoutsService,
    private router: Router,
    private coreTranslate: CoreTranslateService,
  ) {

    console.log('layoutsService', this.layoutsService.checkIsDesktop());
    this.coreTranslate.initialLanguage();

    this.config.theme.set({
      preset: configTheme,
      options: {
        darkModeSelector: '.p-dark',
        cssLayer: {
          name: 'primeng',
          order: 'tailwind-base, primeng, tailwind-utilities, project'
        }
      },
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.routerLoadingValue = 0;
        this.isRouterLoading = true;
        this.intervalL = setInterval(() => {
          this.routerLoadingValue += 5;
          if (this.routerLoadingValue < 80) {
            clearInterval(this.intervalL);
          }
        }, 100);
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        clearInterval(this.intervalL);
        this.routerLoadingValue = 100;
        setTimeout(() => {
          this.isRouterLoading = false;
          setTimeout(() => {
            this.routerLoadingValue = 0;
          }, 500);
        }, 800);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.layoutsService.onResizeWindow(event)
  }

}
